import { stateDropdown } from '@/fetchers/backend-fetchers';
import { useQuery } from '@tanstack/react-query';

export const useStates = () => {
  const { data: states } = useQuery({
    queryKey: ['state-dropdown'],
    queryFn: stateDropdown,
    select: (data) => data?.data,
  });
  return states;
};
